import WaagChart from "./WaagChart";
import UserToDoList from "./UserToDoList";
import ClinicianHoursChart from "./ClinicianHoursChart";
import ConflictManagement from "../admin/ConflictManagement";
export default function OwnerDashboardComponent({ onAppointmentClick, onReschedule, onWideSidePanelClose }) {
  return (
    <div className="space-y-6 pb-20">
      {/* Conflict Management Section */}
      <div className="bg-white rounded-lg shadow">
        <ConflictManagement onAppointmentClick={onAppointmentClick} />
      </div>

      {/* Main Dashboard Grid */}
      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-3">
          <WaagChart />
          <ClinicianHoursChart />
          <UserToDoList />
        </div>
      </div>
    </div>
  );
}
